/// <amd-module name="WidgetCommon/ConfigContracts/TeamWidgetSettings" />
export interface TeamWidgetSettings {
    teamId: string;
}
